export var ParentEnvelope;
(function (ParentEnvelope) {
    ParentEnvelope["DEV_INT"] = "ParentEnvelope.DEV_INT";
    ParentEnvelope["LOCALHOST"] = "ParentEnvelope.LOCALHOST";
    ParentEnvelope["PREVIEW_CBS"] = "ParentEnvelope.PREVIEW_CBS";
    ParentEnvelope["PREVIEW_INT"] = "ParentEnvelope.PREVIEW_INT";
    ParentEnvelope["PREVIEW_PPLUS"] = "ParentEnvelope.PREVIEW_PPLUS";
    ParentEnvelope["PROD_CBS"] = "ParentEnvelope.PROD_CBS";
    ParentEnvelope["PROD_INT"] = "ParentEnvelope.PROD_INT";
    ParentEnvelope["PROD_PPLUS"] = "ParentEnvelope.PROD_PPLUS";
    ParentEnvelope["SHADOW_CBS"] = "ParentEnvelope.SHADOW_CBS";
    ParentEnvelope["SHADOW_INT"] = "ParentEnvelope.SHADOW_INT";
    ParentEnvelope["SHADOW_PPLUS"] = "ParentEnvelope.SHADOW_PPLUS";
    ParentEnvelope["STAGE_CBS"] = "ParentEnvelope.STAGE_CBS";
    ParentEnvelope["STAGE_INT"] = "ParentEnvelope.STAGE_INT";
    ParentEnvelope["STAGE_PPLUS"] = "ParentEnvelope.STAGE_PPLUS";
    ParentEnvelope["TEST_WWW_CBS"] = "ParentEnvelope.TEST_WWW_CBS";
    ParentEnvelope["TEST_WWW_PPLUS"] = "ParentEnvelope.TEST_WWW_PPLUS";
    ParentEnvelope["VIDOPSTEST_CBS"] = "ParentEnvelope.VIDOPSTEST_CBS";
    ParentEnvelope["VIDOPSTEST_INT"] = "ParentEnvelope.VIDOPSTEST_INT";
    ParentEnvelope["VIDOPSTEST_PPLUS"] = "ParentEnvelope.VIDOPSTEST_PPLUS";
})(ParentEnvelope || (ParentEnvelope = {}));
